import { Analytics } from './AnalyticsClient';
import { getQueryParamOrHash } from './getQueryParamOrHash';
import { isEmbeddedDocument } from '@trello/browser';
import { memberId } from '@trello/session-cookie';
import { tenantType, userType } from '@atlassiansox/analytics-web-client';

/*
 * list populated from bitbucket names in server at
 * https://bitbucket.org/trello/server/src/b899043498abd922d9a633a7fce88bcf3362ba3f/conf/trellis.defaults.js?fileviewer=file-view-default#trellis.defaults.js-449:465
 */
const emauEmbeddedAllowlist = ['bb', 'bb-staging', 'bb-bello', 'bb-bello-dev'];

export const initialize = () => {
  const emauEmbeddable = emauEmbeddedAllowlist.includes(
    getQueryParamOrHash('iframeSource') || '',
  );

  Analytics.setTenantInfo(tenantType.NONE);

  if (memberId) {
    Analytics.setUserInfo(userType.TRELLO, memberId);

    if (!isEmbeddedDocument() || emauEmbeddable) {
      Analytics.startUIViewedEvent();
    }
  }
};
